import React from 'react'
import SetScheme from '../../myapp/master/helper/SetScheme'

function SetSchemePage() {
  return (
    <SetScheme/>
  )
}

export default SetSchemePage
